import React from 'react';
import { useNavigate } from 'react-router';

import { getBannerImageUrl, getIsBannerVideo } from '@app/dev/helpers/banners';

export const BannerItemRemote = ({ link, redirectUrl, text, subText, icon }) => {
  const navigate = useNavigate();

  const isExternal = redirectUrl?.startsWith('http');

  const onNavigate = () => {
    if (!redirectUrl) return;
    if (isExternal) {
      window.open(redirectUrl, '_self');
    } else {
      navigate(redirectUrl);
    }
  };

  const isVideo = getIsBannerVideo(link || '');


  return (
    <div
      className={`home-banner ${isVideo ? 'home-banner-video' : ''}`}
      onClick={redirectUrl ? onNavigate : undefined}
      style={{ cursor: redirectUrl ? 'pointer' : 'default' }}
    >
      {isVideo ? (
        <video src={getBannerImageUrl(link)} className="home-banner-image" autoPlay loop muted playsInline />
      ) : (
        <img src={getBannerImageUrl(link)} alt={text || ''} className="home-banner-image" />
      )}
      {(text || subText) && (
        <div className="home-banner-content">
          {text && <span className="home-banner-text">{text}</span>}
          {subText && <span className="home-banner-sub-text">{subText}</span>}
        </div>
      )}
      {icon && (
        <img src={`data:image/png;base64,${icon}`} alt="" className="home-banner-icon" />
      )}
    </div>
  );
};
